import React from "react";
import Grid from "@mui/material/Grid";
import Dropdown, { TDropdownItem } from "components/dropdown";
import AppBar from "@mui/material/AppBar";
import { styled, Typography } from "@mui/material";
import colors from "styles/colors";
import { LocalizeText } from "components/localizer";
import { TLanguageTag } from "contexts/language";

const StyledAppBar = styled(AppBar)(({ theme }) => ({
    backgroundColor: "transparent",
    boxShadow: "none",
    color: colors.black,
    "& button": {
        opacity: 1,
    },
    "& .MuiTabs-root > div > span": {
        backgroundColor: colors.vkOrange,
        height: 4,
    },
}));

interface IProps {
    titleTag?: TLanguageTag;
    searchField?: React.ReactNode;
    tabs?: React.ReactNode;
    menuItems?: TDropdownItem[];
    singleItem?: React.ReactNode;
    buttons?: React.ReactNode;
}
const TopBar: React.FC<IProps> = ({ titleTag, searchField, tabs, menuItems, singleItem, buttons }) => (
    <Grid container sx={{ height: "3em" }} justifyContent={"space-between"}>
        <Grid container item xs={8}>
            {titleTag && <Typography variant="h6">
                <LocalizeText tag={titleTag} />
            </Typography>}
            {searchField && searchField}
            {buttons && buttons}
            {tabs && <StyledAppBar position="static">{tabs}</StyledAppBar>}
            {!searchField && !tabs && <Grid container item xs={9} alignItems={"center"} />}
        </Grid>

        <Grid
            item
            xs={4}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "1em",
            }}
        >
            {singleItem}
            {menuItems && menuItems.length > 0 && <Dropdown items={menuItems} />}
        </Grid>
    </Grid>
);

export default TopBar;
